import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@wundo/ui';
import { m } from '@/paraglide/messages.js';

export interface MeetingRegenerateDialogProps {
  open: boolean;
  title: string;
  /** What making it again costs, in the user's own terms. */
  body: string;
  confirmLabel: string;
  failed: boolean;
  pending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * The confirm in front of "opnieuw maken".
 *
 * It says outright what survives, because that is the whole question the user
 * has, and the answer differs per panel. So the copy is the caller's, and the
 * dialog only promises to show it before anything moves.
 */
export function MeetingRegenerateDialog({
  open,
  title,
  body,
  confirmLabel,
  failed,
  pending,
  onConfirm,
  onCancel,
}: MeetingRegenerateDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onCancel()}>
      <DialogContent size='md'>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <div className='flex flex-col gap-2.5 px-5 py-4'>
          <p className='text-sm text-ink-body'>{body}</p>
          {failed && (
            <p role='alert' className='text-sm text-danger'>
              {m.meeting_action_failed()}
            </p>
          )}
        </div>

        <DialogFooter>
          <Button size='sm' variant='quiet' onClick={onCancel}>
            {m.meeting_cancel()}
          </Button>
          <Button size='sm' loading={pending} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
